import "./Fusion/Index";

if (process.env.NODE_ENV == "development") {
    console.log("JvMTECH.Components Main.js loaded");
}

function calculateScrollbarWidth() {
    document.documentElement.style.setProperty(
        "--scrollbar-width",
        window.innerWidth - document.documentElement.clientWidth + "px"
    );
}

window.addEventListener("resize", calculateScrollbarWidth, false);
document.addEventListener("DOMContentLoaded", calculateScrollbarWidth, false);
window.addEventListener("load", calculateScrollbarWidth);
